<div class="mat-elevation-z3 history">
  <mat-card class="historyHeader">
    <mat-form-field>
      <mat-select placeholder="表示月" id="month" name="month" [(ngModel)]="selectMonth" #month="ngModel">
        <mat-option *ngFor="let m of monthes" [value]="m.id">{{m.value}}</mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-raised-button (click)="savePDFReport()">PDF出力</button>
  </mat-card>
  <div class="mat-elevation-z3 history">
    <ul class="record-list" *ngIf="dataSub$ | async as records">
      <li>
        <div class="record-header">
          <p>日付</p>
          <p>出社</p>
          <p>退社</p>
          <p>外出</p>
          <p>戻り</p>
          <p class="status">状態</p>
        </div>
        <mat-divider></mat-divider>
      </li>
      <ng-container *ngFor="let record of records; index as index;">
        <li class="record-list-item" *ngIf="(2 <= index && index <= records.length - 3)">
          <app-own-histories-detail [reportRecord]="record" (update)="update()"></app-own-histories-detail>
        </li>
        <hr *ngIf="!last">
      </ng-container>
    </ul>
  </div>
</div>
